import { messages } from './connection-sync-table.messages';

import type { ConnectionConfig } from '../../../../../../../inventory-sync/types/inventory-sync-types';
import type { IntlShape } from 'react-intl';

const SUMMARY_SEPARATOR = '; ';

export const formatSyncConfigSummary = (intl: IntlShape, config: ConnectionConfig): string => {
  const parts: string[] = [];

  if (config.min_sellable_quantity_enabled && config.min_sellable_quantity !== undefined) {
    parts.push(intl.formatMessage(messages.configSummaryMinimum, { quantity: intl.formatNumber(config.min_sellable_quantity) }));
  }

  if (config.max_sellable_quantity_enabled && config.max_sellable_quantity !== undefined) {
    parts.push(intl.formatMessage(messages.configSummaryMaximum, { quantity: intl.formatNumber(config.max_sellable_quantity) }));
  }

  if (config.buffer_stock_quantity_enabled && config.buffer_stock_quantity !== undefined) {
    parts.push(intl.formatMessage(messages.configSummaryBuffer, { quantity: intl.formatNumber(config.buffer_stock_quantity) }));
  }

  if (config.sync_percentage_quantity_enabled && config.sync_percentage_quantity !== undefined) {
    parts.push(
      intl.formatMessage(messages.configSummaryPercentage, {
        percentage: intl.formatNumber(config.sync_percentage_quantity),
      }),
    );
  }

  return parts.length > 0 ? parts.join(SUMMARY_SEPARATOR) : intl.formatMessage(messages.configSummaryNoRules);
};
